<template>
  <div class="pop-box">
    <!-- 底部立即体验弹出 -->
    <van-popup
      id="practicePopup"
      v-model="practiceMenuShow"
      clearable
      closeable
      round
      position="bottom"
      @close="handleClosePop"
    >
      <div class="title">立即体验</div>
      <div class="formData">
        <van-form ref="ruleForm" @submit="handleSubmit">
          <Businessnformation
            :needFlag="true"
            v-model="formData.companyname"
            @change="customerNameChange"
            @focus="inputFocus(ruleForm.companyRules)"
            @blur="inputBlur"
            :class="{ handleStyle1: handleStyle1 }"
            :isClear="isClear"
            @getName="getName"
          ></Businessnformation>
          <van-field
            label=" |"
            :left-icon="practice2"
            :rules="ruleForm.usernameRules"
            v-model="formData.username"
            clearable
            placeholder="请输入您的姓名"
            :border="false"
          />
          <van-field
            label="|"
            :left-icon="practice3"
            :rules="ruleForm.telRules"
            type="tel"
            v-model="formData.phone"
            clearable
            placeholder="请输入您的联系方式"
            @input="onPhoneChange"
            :border="false"
          />
          <!-- 暂时隐藏验证码 -->
                            <el-form-item prop="checkCode">
                                <el-input v-model="experienceForm.checkCode"
                                    placeholder="请输入验证码"
                                    @focus="experienceFocus('handleStyle2')"
                                    @blur="experienceBlur('handleStyle2')">
                                    <template slot="append">
                                    <el-button class="send-sms-btn"
                                            :disabled="isSmsSend"
                                            @click="sendSmsCode">{{sendBtnText}}</el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
          <div class="btns">
            <van-button
              type="info"
              native-type="submit"
              @click="handleSubmitStyle"
              >开始体验</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- 底部立即体验提交后弹出的窗口 -->
    <van-popup
      id="afterPracticePopup"
      v-model="afterPracticeMenuShow"
      closeable
      round
      position="bottom"
      @close="handleAfterClosePop"
    >
      <div class="bg">
        <img src="../../assets/img/phoneHomePage/afterPop.png" />
      </div>
      <div class="context">
        <div class="title">提交成功</div>
        <div class="text">我们会在3个工作日内与您联系，请注意接听来电</div>
        <van-button type="info" @click="handleAfterClosePop">好的</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Businessnformation from "./Businessnformation";
import { sendCode, submitForm } from "../../api/form";
export default {
  name: "ExperienceNow",
  components: {
    Businessnformation,
  },
  props: {
    isPopShow: Boolean,
  },
  data() {
    return {
      practiceMenuShow: false, // 立即体验弹窗
      afterPracticeMenuShow: false, // 提交表单后弹窗
      handleStyle1: false, // 公司名称表单样式
      handleStyle2: false, // 验证码表单样式
      isClear: false, // 是否可清除
      isSmsSend: false, // 发送验证码按钮
      sendBtnText: "获取验证码", // 显示文本
      timer: null, // 计时器对象
      counter: 60, // 倒数60秒
      practice2: require("../../assets/img/phoneHomePage/practice-2.png"),
      practice3: require("../../assets/img/phoneHomePage/practice-3.png"),
      practice4: require("../../assets/img/phoneHomePage/practice-4.png"),
      ruleForm: {
        companyRules: [
          {
            required: true,
            // message: '请输入您的单位名称'
          },
        ],
        telRules: [
          {
            required: true,
            // message: '手机号码不能为空',
            trigger: "onChange",
          },
          {
            // 手机号校验规则
            validator: (value) => {
              return /^1[3-9]\d{9}$/.test(value);
            },
            // message:'请输入正确的手机号码',
            trigger: "onBlur",
          },
        ],
        usernameRules: [
          {
            required: true,
            // message: '请输入您的姓名'
          },
        ],
      },
      formData: {
        companyname: "", // 企业名称
        username: "",
        phone: "",
        checkCode: "", // 验证码
        sourceway: "", // 访问途径
        registerProduct: "轻骑兵", // 注册信息的产品
        interestProduct: "轻骑兵", // 感兴趣产品
        concreteDemand: "", // 具体需求
      },
    };
  },
  watch: {
    isPopShow() {
      this.practiceMenuShow = this.isPopShow;
    },
  },
  methods: {
    // 关闭立即体验
    handleClosePop() {
      const self = this;
      self.$emit("CloseExperienceNow");
      self.formData.companyname = "";
      self.formData.username = "";
      self.formData.phone = "";
      self.formData.checkCode = "";
      self.handleStyle1 = false;
      self.handleStyle2 = false;
      self.isClear = !self.isClear;
      setTimeout(() => {
        self.$refs.ruleForm.resetValidation();
      }, 300);
      self.reset();
    },
    // 重置倒计时
    reset() {
      const self = this;
      self.isSmsSend = false;
      self.sendBtnText = "获取验证码";
      if (self.timer) {
        clearInterval(self.timer);
        self.counter = 60;
        self.timer = null;
      }
    },
    // 提交表单
    handleSubmit() {
      const self = this;
      let error = false;
      if (self.formData.checkCode === "") {
        self.handleStyle2 = true;
        return;
      }
      self.$refs.ruleForm.validate((valid) => {
        if (valid) {
          error = false;
        } else {
          error = true;
        }
      });
      if (error) {
        return;
      }
      const param = self.formData;
      if (param) {
        submitForm(param)
          .then((res) => {
            if (
              (res.status === "200" || res.status === 200) &&
              res.data === "注册成功"
            ) {
              self.$message.success("提交成功!");
              self.practiceMenuShow = false;
              self.handleClosePop();
              self.afterPracticeMenuShow = true;
            } else if (
              (res.status === "200" || res.status === 200) &&
              res.data === ""
            ) {
              self.$message.warning("该手机号已经体验过!");
              self.practiceMenuShow = false;
              self.handleClosePop();
            } else {
              self.$message.error(res.data);
              self.handleClosePop();
            }
          })
          .catch((error) => {
            self.$message.error("提交失败!");
            self.practiceMenuShow = false;
            self.handleClosePop();
          });
      }
    },
    // 公司名称赋值
    getName(params) {
      const self = this;
      self.formData.companyname = params.value;
    },
    // 当手机号变化时，重置发送按钮
    onPhoneChange() {
      const self = this;
      self.reset();
    },
    // 校验手机号
    checkPhone() {
      const self = this;
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(self.formData.phone)) {
        return false;
      }
      return true;
    },
    // 发送验证码
    sendCode() {
      const self = this;
      self.handleSubmitStyle();
      if (!self.checkPhone()) {
        return;
      }
      sendCode(self.formData.phone)
        .then((res) => {
          console.log("res:"+res)
          if ((res.status === "200" || res.status === 200) && res.data.msg === "发送成功") {
            console.log("res:"+res)
            self.$message.success("验证码发送成功!");
            // 将按钮禁用，防止再次点击
            self.isSmsSend = true;
            self.countDown();
          } else {
            self.$message.error(res.data);
          }
        })
        .catch((error) => {
          self.$message.error("验证码发送失败!");
        });
    },
    // 关闭定时器
    countDown() {
      console.log("关闭定时器")
      const self = this;
      self.timer = setInterval(() => {
        self.sendBtnText = `(${self.counter}秒)后重新发送`;
        self.counter--;
        if (self.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(self.timer);
          self.reset();
        }
      }, 1000);
    },
    // 修改单位名称表单输入文字
    handleSubmitStyle() {
      const self = this;
      if (!self.formData.companyname) {
        self.handleStyle1 = true;
      }
    },
    // 关闭提交表单后的弹出层
    handleAfterClosePop() {
      const self = this;
      self.afterPracticeMenuShow = false;
    },
    customerNameChange() {},
    inputFocus() {},
    inputBlur() {},
  },
};
</script>
<style scoped>
#practicePopup .title {
  font-size: 19px;
  text-align: center;
  margin: 23px 13px 5px 13px;
  font-weight: 500;
}
.formData {
  display: flex;
  justify-content: center;
}
.formData > .van-form > .van-field {
  border: #f3f0f0 solid 1px !important;
  margin: 15px 10px;
  width: calc(100% - 20px);
  align-items: center;
}
.van-cell {
  padding-left: 8px;
  align-items: center;
}
/deep/ .van-field__label {
  width: 0 !important;
}
#practicePopup .btns {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 20px;
}
#practicePopup .btns > .van-button {
  font-size: 17px;
  width: calc(100% - 20px);
}
.van-form {
  border: none !important;
  width: 100%;
}
#afterPracticePopup .bg {
  margin: 40px 0 20px 0;
  text-align: center;
}
#afterPracticePopup .bg > img {
  height: 70px;
}
#afterPracticePopup .context {
  text-align: center;
}
#afterPracticePopup .context .title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
#afterPracticePopup .context .text {
  font-size: 14px;
  margin-bottom: 30px;
}
#afterPracticePopup .context .van-button {
  width: 90%;
  font-size: 14px;
  margin-bottom: 30px;
}

/deep/ .van-field__control::placeholder {
  /* color: #888; */
  font-size: 15px;
}
/deep/ .handleStyle1 .van-field__control::placeholder {
  color: #ee0a24 !important;
}
.sendBtnText {
  font-size: 16px;
  color: cornflowerblue;
  border: none;
}
/deep/ .clickSend:focus {
  background: rgb(238, 247, 254);
}
</style>



// WEBPACK FOOTER //
// src/components/include/ExperienceNow.vue